<template>
    <div>
        <div :class="'superChallengePage anim'+ ( open ? ' open' : '' )">
            <div v-if="open" class="container h-100 animate__animated animate__fadeIn">
                <div class="bird-house">
                    <a @click.prevent="info();btnSfx();" href="#">&nbsp;</a>
                    <div v-if="superChallenge != null" class="limit-info text-center">
                        <div>{{ $t('super_ch.participants') }}</div>
                        <b :class="superChallenge.participantCount >= superChallenge.participantLimit ? 'red' : ''">{{ superChallenge.participantCount }} / {{ superChallenge.participantLimit }}</b>
                    </div>
                </div>

                <div class="bear-video p-lg-3 animate__animated animate__slow animate__fadeIn">
                    <video v-if="superChallenge != null && superChallenge.userApplied" :src="user.mtsCustomer ? '/video/mts/bird-applied.mp4':'/video/default/bird-applied.mp4'" type="video/mp4" muted autoplay loop playsinline>Your browser does not support the video.</video>
                    <video v-else :src="user.mtsCustomer ? '/video/mts/bird-wait.mp4':'/video/default/bird-wait.mp4'" type="video/mp4" muted autoplay loop playsinline>Your browser does not support the video.</video>
                </div>

                <div class="row h-100">
                    <div class="col-md-6 h-100 m-auto d-flex flex-fill flex-column relative">
                        <a @click.prevent="hide();btnSfx();" href="#" class="btnClose"></a>
                        <div class="content">
                            <a @click.prevent="info();btnSfx();" href="#" class="info-btn"><i></i></a>
                            <div v-if="superChallenge != null" class="content-bottom text-center">
                                <template v-if="superChallenge.status == 'IN_PROGRESS' || startDate == '00:00h'">
                                    <div class="d-flex">
                                        <h3 v-if="superChallenge.userApplied" class="text-success ml-auto mr-auto mt-3 mb-3">{{ $t('super_ch.start_info_in') }}</h3>
                                        <h3 v-else class="text-success ml-auto mr-auto mt-3 mb-3">{{ $t('super_ch.start_info') }}</h3>
                                    </div>
                                </template>
                                <template v-else-if="!superChallenge.userApplied && superChallenge.participantCount >= superChallenge.participantLimit">
                                    <div class="d-flex">
                                        <h3 class="text-danger ml-auto mr-auto mt-3 mb-3">{{ $t('super_ch.participant_limit_info') }}</h3>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="p-3">
                                        <div :class="'startDateTime mb-2'+(superChallenge.userApplied ? '' : ' sm')">
                                            <span>{{ $t('super_ch.wait_start_at') }}</span> 
                                            {{ startDate }}
                                        </div>
                                        <b-button v-if="!superChallenge.userApplied" @click="apply();btnSfx();" size="lg" variant="yellow" class="mb-lg-4"> 
                                            <span v-if="superChallenge.stake > 0">{{ superChallenge.stake.abbr(true) }} <img src="/images/challenges/token-white.png"/></span> 
                                            {{ $t('super_ch.apply_btn') }}
                                        </b-button>
                                    </div>
                                </template>
                                <div class="award ml-md-3 mr-md-3">
                                    {{ $t('super_ch.award') }}
                                    <span><img src="/images/token.png"/> {{ superChallenge.awardsBudget.abbr(true) }} <img v-if="superChallenge.participantCount < superChallenge.participantLimit" src="/images/home/super_challenges/arrow-top.png" class="growing"/></span>
                                </div>
                            </div>
                            <div v-else class="content-bottom text-center">
                                <h5 class="text-primary m-auto">{{ $t('super_ch.no_ch_info') }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <super-challenge-info-popup ref="infoPopup"></super-challenge-info-popup>
    </div>
</template>

<script>
import Vue from 'vue'
import api from '../api'

import SuperChallengeInfoPopup from './SuperChallengeInfoPopup.vue';

const SuperChallenge = Vue.component('super-challenge', {
    components: {
        SuperChallengeInfoPopup
    },
    startDateTimer: null,
    data(){
    	return {
            open: false,
            startDate: '00:00h',
    	};
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        superChallenge() {
            return this.$store.state.superChallenge.obj;
        },
        networkTimeDiff(){
            return this.$store.state.config.networkTimeDiff;
        }
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            this.open = true;
            this.$store.dispatch('superChallenge/getChallenge');
            this.$emit("hideBottomNav", true);
            document.querySelectorAll(".user-resources .profile")[0].style.visibility = 'hidden';
        },

        hide() {
            this.open = false;
            this.clearTimers();
            this.$emit("hideBottomNav", false);
            document.querySelectorAll(".user-resources .profile")[0].style.visibility = 'visible';
        },  

        apply(){
            const $this = this;

            if(this.superChallenge.stake > this.user.tokens){
                this.$root.$bvModal.msgBoxOk(this.$t('shop.shop_no_tokens'), {
                    title: this.$t('shop.shop_no_resources_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    this.$store.dispatch('sound/sfx','Button');
                });

                return false;
            }

            this.$bvModal.msgBoxConfirm(this.$t('super_ch.popup_apply_text', { stake: this.superChallenge.stake.abbr(true) }), {
                title: this.$t('super_ch.popup_apply_title'),
                okTitle: this.$t('base.btn_yes'),
                cancelTitle: this.$t('base.btn_no'),
                size: 'sm',
                buttonSize: 'lg',
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    let loader = document.getElementById('loader');
                    loader.classList.add("show");

                    api.superChallengeApply($this.superChallenge.id)
                        .then((data) => {
                            $this.$store.dispatch('superChallenge/getChallenge');
                        })
                        .catch(function (error) {
                            api.baseErrorHendler(error);
                        })
                        .then(function () {
                            loader.classList.remove("show");
                        });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        info(){
            this.$refs.infoPopup.show();
        },

        formatTime(time){
            if(time < 0) time = 0; // fix negative 
            let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff));

            if(t.asDays() > 1)
                return t.days()+"d"+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ "h" : "");
            else if(t.hours() > 0)
                return this.pad2(t.hours()) + ":" + this.pad2(t.minutes())+"h";
            else if(t.minutes() > 0)
                return this.pad2(t.minutes()) + ":" + this.pad2(t.seconds())+"m";

            return '00:'+this.pad2(t.seconds())+"s";
        },
        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },

        clearTimers(){
            if(this.startDateTimer != null){
                clearInterval(this.startDateTimer);
                this.startDateTimer = null;
            }
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
        this.clearTimers();
    },

    watch:{
        superChallenge(){
            this.clearTimers();
            if(this.superChallenge != null){
                const $this = this;

                if(this.superChallenge.startDate != undefined){
                    this.startDate = $this.formatTime(this.superChallenge.startDate); 
                    this.startDateTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isBefore($this.superChallenge.startDate))
                            $this.startDate = $this.formatTime($this.superChallenge.startDate);
                        else $this.startDate = "00:00s";
                    }, 1000);
                }
            }
        },
    }
});

export default SuperChallenge
</script>
